export default "__VITE_ASSET__48f02d57__"